// extracted by mini-css-extract-plugin
module.exports = {"root":"NotificacaoTitle_root__8tyDY","title":"NotificacaoTitle_title__3uLwP"};